import React from 'react';
import { Link } from 'react-router-dom';

export default class AboutTwo extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="about-one about-one--two">
                    <div className="shape4"><img src={publicUrl+"assets/images/shapes/about-v1-shape4.png"} alt="#" /></div>
                    <div className="container">
                        <div className="row">
                            {/* Start About One Left */}
                            <div className="col-xl-6">
                                <div className="about-one__left">
                                    <div className="about-one__left-img">
                                        <div className="shape1 float-bob-y"></div>
                                        <div className="shape2 float-bob-y"></div>
                                        <div className="shape3 float-bob-y"></div>
                                        <img src={publicUrl+"assets/images/about/about-v1-img1.jpg"} alt="#" />
                                    </div>
                                </div>
                            </div>
                            {/* End About One Left */}

                            {/* Start About One Right */}
                            <div className="col-xl-6">
                                <div className="about-one__right">
                                    <div className="about-one__right-title">
                                        <h2>Connecting Southwest Florida to Fresh, Local Food</h2>
                                    </div>

                                    <div className="about-one__right-text1">
                                        <p>Fresh SWFL is your comprehensive guide to discovering the vibrant local food scene across Southwest Florida, from Fort Myers to Naples.</p>
                                    </div>
                                    <div className="about-one__right-text2">
                                        <p>Southwest Florida is home to dozens of local farms, farmers markets, farm stands, and U-pick locations offering fresh, seasonal produce year-round. We believe that connecting our community with local food sources strengthens our regional food system, supports local agriculture, and provides families with access to the freshest, most nutritious foods available. Our mission is to make it easy for residents and visitors to find and support local farmers, discover seasonal produce, and embrace a farm-to-table lifestyle in Southwest Florida.</p>
                                    </div>
                                    <div className="about-one__right-text3">
                                        <div className="about-one__right-text3-icon" style={{backgroundImage: 'url('+publicUrl+'assets/images/shapes/about-v1-shape5.png)'}}>
                                            <span className="icon-budget"></span>
                                        </div>
                                        <div className="about-one__right-text3-content">
                                            <h2>Supporting Local Agriculture</h2>
                                            <p>When you buy from local farms, you're investing in your community, reducing food miles, and enjoying peak-season freshness.</p>
                                        </div>
                                    </div>
                                    <div className="about-one__right-text4">
                                        <p>Our platform features verified listings of local farms, weekly farmers markets in Fort Myers, Cape Coral, Bonita Springs, Naples, and surrounding areas, CSA programs offering farm-fresh subscription boxes, U-pick farms for family experiences, and farm stands with direct-from-farm produce. Whether you're searching for organic vegetables, tropical fruits, fresh herbs, or pasture-raised meats, Fresh SWFL connects you with trusted local sources committed to sustainable farming practices and quality food production.</p>
                                    </div>
                                    <div className="about-one__right-btn">
                                        <Link to={process.env.PUBLIC_URL + `/directory`} className="thm-btn">Explore Directory</Link>
                                    </div>
                                </div>
                            </div>
                            {/* End About One Right */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}